import React from 'react';
import { SectionHeader } from '../../components';

const CompanyStorySection = () => {
  return (
    <section className="section-padding">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6" data-aos="fade-right">
            <SectionHeader
              title="Our Story"
              description="Founded with a vision to transform how businesses approach digital growth, GrowthVibe emerged from the recognition that traditional marketing agencies often fall short in delivering measurable, sustainable results. Our founders, Jinit, Meet, and Ansh, brought together their diverse expertise in marketing, technology, and operations to create an agency that truly understands the modern digital landscape. Today, we're proud to have helped hundreds of businesses achieve their growth goals through our comprehensive, data-driven approach."
              textAlign="text-start"
            />
          </div>
          <div className="col-lg-6" data-aos="fade-left">
            <div className="about-image">
              <img 
                src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" 
                alt="GrowthVibe Team" 
                className="img-fluid rounded-3 shadow"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyStorySection;
